import React from "react";
import { imagePlaceholder } from "../../utils/confs";

function InfoWindowContent({ marker }) {
  const {
    title,
    image,
    link,
    indirizzo,
    prezzo,
    tipologia_contratto,
    camere,
    bagni,
    sq_ft,
  } = marker;

  const label_color = tipologia_contratto == "vendita" ? "#A01E5E" : "#87A550";

  const minIcons = [
    camere && {
      icon: "fas fa-bed",
      text: camere,
    },
    bagni && {
      icon: "fas fa-bath",
      text: bagni,
    },
    sq_ft && {
      icon: "fas fa-ruler",
      text: sq_ft,
    },
  ];

  return (
    <div>
      <div className="infobox-card uk-position-relative">
        <div className="uk-position-top-right">
          <div
            className="infobox-label"
            style={{ backgroundColor: label_color, color: "white" }}
          >
            {tipologia_contratto}
          </div>
        </div>
        <div className="uk-card-media-top">
          <img
            src={image ?? imagePlaceholder}
            alt={title}
            style={{ width: "100%", height: "150px", objectFit: "cover" }}
          />
        </div>
        <div className="uk-card-body">
          <div className="infobox-card-inner-info">
            <div className="infobox-prezzo">
              <h5>
                <span style={{ color: "#BB005F" }}>{prezzo} €</span>
              </h5>
            </div>
            <div>
              <a href={link}>
                <h5 className="uk-h5">{title}</h5>
              </a>
              <p className="uk-meta uk-margin-remove-top">
                <i className="fas fa-map-marker-alt uk-margin-small-right"></i>
                {indirizzo}
              </p>
            </div>
          </div>
          <div className="infobox-card-body-header">
            {minIcons.length > 0 && (
              <div className="infobox_icons uk-flex uk-flex-middle ">
                {minIcons.map(
                  (icon) =>
                    icon && (
                      <div className="infobox-icon uk-margin-small-right">
                        <i className={icon.icon} />
                        <span className="uk-margin-small-left">
                          {icon.text}
                        </span>
                      </div>
                    ),
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoWindowContent;
